import forms from '@/libs/forms';

const getPaymentMethodField = (paymentMethods, openPaymentMethodModal) => {
  const select = forms.simpleSelect(null, 'paymentMethod', true, paymentMethods);
  select.buttons = [{
    label: '+ New',
    onclick: openPaymentMethodModal,
  }];
  return select;
};

export default {
  schema: (paymentMethods, openPaymentMethodModal) => ({
    schema: {
      groups: [{
        legend: 'Payment Method',
        fields: [getPaymentMethodField(paymentMethods, openPaymentMethodModal)],
      }],
    },
    options: forms.options('new-payment-method-', true),
  }),
};



// WEBPACK FOOTER //
// ./src/components/payments/create/resources/selectSchema.js